<h2 mat-dialog-title class="popup-title"><mat-icon>{{ options.icon || 'help_outline' }}</mat-icon>{{ options.title || 'Confirm action' }}</h2>
<div mat-dialog-content class="popup-content">
  <p class="popup-description">{{ message }}</p>
  @if (options.recordName) { <div class="popup-record"><span>{{ options.recordLabel || 'Record' }}</span><strong>{{ options.recordName }}</strong></div> }
</div>
<div mat-dialog-actions class="popup-actions">
  <button mat-stroked-button (click)="onNoClick()">{{ options.cancelLabel || 'Cancel' }}</button>
  <button mat-flat-button class="popup-primary" [class.popup-danger]="options.destructive" [mat-dialog-close]="true">{{ options.confirmLabel || 'Confirm' }}</button>
</div>
